import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PickableCustomersOrdersDataGrid } from "src/components/views/erp/sales/delivery/picking/PickableCustomersOrdersDataGrid.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/sales/picking/pickableCustomerOrders")({
	staticData: { title: i18n.t("pickable_customer_orders"), legacyViewKey: "pickableCustomersOrdersDataGrid" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <PickableCustomersOrdersDataGrid isActive={isActive} />;
}
